// src/assets/card-images.ts
import cardAClub from './card-icons/clubs/1.png';
import card2Club from './card-icons/clubs/2.png';
import card3Club from './card-icons/clubs/3.png';
import card4Club from './card-icons/clubs/4.png';
import card5Club from './card-icons/clubs/5.png';
import card6Club from './card-icons/clubs/6.png';
import card7Club from './card-icons/clubs/7.png';
import card8Club from './card-icons/clubs/8.png';
import card9Club from './card-icons/clubs/9.png';
import card10Club from './card-icons/clubs/10.png';
import cardJClub from './card-icons/clubs/11.png';
import cardQClub from './card-icons/clubs/12.png';
import cardKClub from './card-icons/clubs/13.png';
import cardADiamond from './card-icons/diamonds/1.png';
import card2Diamond from './card-icons/diamonds/2.png';
import card3Diamond from './card-icons/diamonds/3.png';
import card4Diamond from './card-icons/diamonds/4.png';
import card5Diamond from './card-icons/diamonds/5.png';
import card6Diamond from './card-icons/diamonds/6.png';
import card7Diamond from './card-icons/diamonds/7.png';
import card8Diamond from './card-icons/diamonds/8.png';
import card9Diamond from './card-icons/diamonds/9.png';
import card10Diamond from './card-icons/diamonds/10.png';
import cardJDiamond from './card-icons/diamonds/11.png';
import cardQDiamond from './card-icons/diamonds/12.png';
import cardKDiamond from './card-icons/diamonds/13.png';
import cardAHeart from './card-icons/hearts/1.png';
import card2Heart from './card-icons/hearts/2.png';
import card3Heart from './card-icons/hearts/3.png';
import card4Heart from './card-icons/hearts/4.png';
import card5Heart from './card-icons/hearts/5.png';
import card6Heart from './card-icons/hearts/6.png';
import card7Heart from './card-icons/hearts/7.png';
import card8Heart from './card-icons/hearts/8.png';
import card9Heart from './card-icons/hearts/9.png';
import card10Heart from './card-icons/hearts/10.png';
import cardJHeart from './card-icons/hearts/11.png';
import cardQHeart from './card-icons/hearts/12.png';
import cardKHeart from './card-icons/hearts/13.png';
import cardASpade from './card-icons/spades/1.png';
import card2Spade from './card-icons/spades/2.png';
import card3Spade from './card-icons/spades/3.png';
import card4Spade from './card-icons/spades/4.png';
import card5Spade from './card-icons/spades/5.png';
import card6Spade from './card-icons/spades/6.png';
import card7Spade from './card-icons/spades/7.png';
import card8Spade from './card-icons/spades/8.png';
import card9Spade from './card-icons/spades/9.png';
import card10Spade from './card-icons/spades/10.png';
import cardJSpade from './card-icons/spades/11.png';
import cardQSpade from './card-icons/spades/12.png';
import cardKSpade from './card-icons/spades/13.png';
import backgroundBlue from './card-icons/card-backgrounds/classic_blue.png';
import backgroundGreen from './card-icons/card-backgrounds/classic_green.png';
import backgroundRed from './card-icons/card-backgrounds/classic_red.png';
import backgroundBrown from './card-icons/card-backgrounds/classic_brown.png';

const cardImages: { [key: string]: string } = {
  cardAClub, card2Club, card3Club, card4Club, card5Club, card6Club, card7Club, card8Club, card9Club, card10Club,
  cardJClub, cardQClub, cardKClub, cardADiamond, card2Diamond, card3Diamond, card4Diamond, card5Diamond,
  card6Diamond, card7Diamond, card8Diamond, card9Diamond, card10Diamond, cardJDiamond, cardQDiamond, cardKDiamond,
  cardAHeart, card2Heart, card3Heart, card4Heart, card5Heart, card6Heart, card7Heart, card8Heart, card9Heart, card10Heart,
  cardJHeart, cardQHeart, cardKHeart, cardASpade, card2Spade, card3Spade, card4Spade, card5Spade, card6Spade,
  card7Spade, card8Spade, card9Spade, card10Spade, cardJSpade, cardQSpade, cardKSpade, backgroundBlue, backgroundGreen,
  backgroundRed, backgroundBrown
};

export default cardImages;
